import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Mail, RefreshCw, CheckCircle, ArrowLeft } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const VerifyEmailPending = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const [resending, setResending] = useState(false);
  const [resendStatus, setResendStatus] = useState(null);

  const handleResend = async () => {
    setResending(true);
    setResendStatus(null);
    try {
      await axios.post(`${API}/auth/resend-verification?email=${encodeURIComponent(email)}`);
      setResendStatus('success');
    } catch (e) {
      setResendStatus('error');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6"
      style={{ background: 'linear-gradient(160deg, #EEF2FF 0%, #F0FDF4 100%)', fontFamily: "'IBM Plex Sans', sans-serif" }}>
      <div className="w-full max-w-md">

        {/* Card */}
        <div className="bg-white/80 backdrop-blur-sm border border-blue-100 rounded-2xl shadow-lg p-8 text-center">

          {/* Icon */}
          <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
            style={{ background: 'linear-gradient(135deg, #EEF2FF, #DBEAFE)' }}>
            <Mail size={36} className="text-blue-600" />
          </div>

          <h1 className="text-2xl font-bold text-blue-900 mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Cek Email Anda
          </h1>

          <p className="text-slate-500 text-sm leading-relaxed mb-2">
            Kami telah mengirim link verifikasi ke:
          </p>
          <div className="inline-block bg-blue-50 border border-blue-200 text-blue-800 font-semibold text-sm px-4 py-2 rounded-xl mb-6">
            {email || 'email Anda'}
          </div>

          <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 text-left mb-6">
            <p className="text-yellow-800 text-sm leading-relaxed">
              <strong>📧 Langkah selanjutnya:</strong><br />
              1. Buka inbox email Anda<br />
              2. Cari email dari <strong>admin@rencanaguru.com</strong><br />
              3. Klik tombol <strong>"Verifikasi Email Saya"</strong><br />
              4. Anda akan langsung masuk ke dashboard
            </p>
          </div>

          <p className="text-slate-400 text-xs mb-4">
            Tidak menerima email? Cek folder <strong>Spam</strong> atau kirim ulang di bawah.
          </p>

          {resendStatus === 'success' && (
            <div className="flex items-center justify-center gap-2 text-green-700 bg-green-50 border border-green-200 rounded-xl px-4 py-3 mb-4 text-sm">
              <CheckCircle size={16} />
              Email verifikasi berhasil dikirim ulang!
            </div>
          )}
          {resendStatus === 'error' && (
            <div className="text-red-600 bg-red-50 border border-red-200 rounded-xl px-4 py-3 mb-4 text-sm">
              Gagal mengirim ulang. Coba beberapa saat lagi.
            </div>
          )}

          <button
            onClick={handleResend}
            disabled={resending}
            className="w-full flex items-center justify-center gap-2 py-3 rounded-xl border-2 border-blue-200 text-blue-700 font-semibold text-sm hover:bg-blue-50 transition-colors disabled:opacity-50 mb-4"
          >
            <RefreshCw size={16} className={resending ? 'animate-spin' : ''} />
            {resending ? 'Mengirim...' : 'Kirim Ulang Email Verifikasi'}
          </button>

          <Link to="/login"
            className="flex items-center justify-center gap-2 text-slate-500 hover:text-blue-700 text-sm transition-colors">
            <ArrowLeft size={14} />
            Kembali ke halaman masuk
          </Link>
        </div>

        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mt-6">
          <img src="/logo.png" alt="RencanaGuru" className="h-7 w-7 object-contain" />
          <span className="font-bold text-blue-900 text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>
            RencanaGuru<span className="text-yellow-500">.com</span>
          </span>
        </div>
      </div>
    </div>
  );
};
